import { getAwsPersonalizeProductsV2 } from "@/services/global/aws-personalize";
import { useSession } from "next-auth/react";
import { useRouter } from "next/router";
import store from "store";
import useSWR from "swr";
import { getCookie } from "cookies-next";
import { getProductsBySkus } from "@/services/product";
import { getMultiProductsRating } from "@/services/product/reviews";
import { useMemo } from "react";

// integrated directly with aws to get products accepts recommenderCode and extraPayload if needed
const useGetAwsPersonalizeProducts = (recommenderCode, extraPayload) => {
  const { data: session } = useSession();
  const { locale } = useRouter();
  const handshake = getCookie("handshake");
  const sessionId = store.get("sessionId") || "";
  const recommenderId = String(session?.user?.id || sessionId);

  // get products sku from aws
  const { data: productsSkuData } = useSWR(
    [
      "aws-personalize-products-sku",
      locale,
      recommenderId,
      recommenderCode,
      extraPayload,
    ],
    () =>
      getAwsPersonalizeProductsV2(recommenderId, recommenderCode, extraPayload),
    {
      revalidateOnFocus: false,
      revalidateOnMount: !!recommenderId,
      revalidateIfStale: true,
      dedupingInterval: 0,
    }
  );

  //  get products
  const productsSku =
    productsSkuData?.itemList?.map((prod) => prod?.itemId) || [];

  const { data: productsData, err } = useSWR(
    `aws-personalize-products/${locale}/${productsSku}/${recommenderCode}`,
    () => getProductsBySkus(handshake, productsSku),
    {
      revalidateOnFocus: false,
      revalidateOnMount: productsSku?.length > 0,
    }
  );

  const products = (productsData?.data?.data?.products || [])?.filter(
    (item) => item?.stock?.is_in_stock && item?.stock?.qty > 0
  );
  console.log('aws----------->>', {productsSku, productsData, err})

  // get products ratings
  const { data: productsRatingsDataRes } = useSWR(
    `aws-personalize-products-ratings/${locale}/${productsSku}/${recommenderCode}`,
    () => getMultiProductsRating(productsSku, handshake),
    {
      revalidateOnFocus: false,
      revalidateOnMount: productsSku?.length > 0,
    }
  );

  const productsRatingsData = useMemo(
    () => productsRatingsDataRes?.data?.data?.at(1) || [],
    [productsRatingsDataRes]
  );

  return {
    products,
    ratings: productsRatingsData,
    // ratings: null,
  };
};

export default useGetAwsPersonalizeProducts;
